<script>
    import { onMount } from "svelte";
    import { getCsvData, setCsvData } from "./common.js"

    export let items = []
    export let csv = ''
    export let selectedItemIndex = -1;
    export let title = ''
    export let textarea = null
    export let edit = false
    let ready = false;

    $ : parseAndUpdateItems(csv)
    $ : updateSelectedLine(selectedItemIndex)

    onMount(() => {
        csv = getCsvData()
        ready = true
        parseAndUpdateItems(csv)
    })

    function parseCSV(str) {
        let result = []
        const lines = str.split('\n');
        for (let i in lines) {
            const line = lines[i]
            if (line.length === 0) {
                continue;
            }

            if (line[0] === '#') {
                continue;
            }

            let entries = line.split(',');
            if (entries.length < 4) {
                continue;
            }
            
            // Do not include 'invalid lines'.
            if (isNaN(entries[1]) || isNaN(entries[2])) {
                continue;
            }

            result.push({
                index: i,
                name: entries[0],
                lat: entries[1],
                lng: entries[2],
                description: entries.slice(3).reduce((acc, current) => acc + current)
            });
        }
        return result;
    }

    let parseAndUpdateItems = (csv) => {
        if (!ready) {
            return
        }
        setCsvData(csv)
        items = parseCSV(csv)
    }

    let updateSelectedItemIndex = (e) => {
        const target = e.target;
        selectedItemIndex = target.value.substr(0, target.selectionStart).split("\n").length - 1;
    }

    function getPosition(string, subString, index) {
        let currentStartIndex = 0;
        while (currentStartIndex !== -1 && index >= 0) {
            currentStartIndex = string.indexOf(subString, currentStartIndex) + 1
            index -= 1;
        }

        return currentStartIndex;
    }

    let updateSelectedLine = (index) => {
        if (!textarea) {
            return;
        }

        const currentSelectedItemIndex = textarea.value.substr(0, textarea.selectionStart).split("\n").length - 1;
        if (currentSelectedItemIndex == selectedItemIndex) {
            return
        }

        let posStart = getPosition(csv, '\n', index-1);
        let posEnd = getPosition(csv, '\n', index);

        if (posEnd === 0) {
            posEnd = csv.length;
        }

        textarea.focus();
        textarea.selectionStart = posStart;
        textarea.selectionEnd = posEnd;
        
        const lineHeight = parseInt(window.getComputedStyle(textarea).lineHeight, 10)
        const offset = index * lineHeight
        textarea.scrollTop = offset
    }
</script>

<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link href="https://fonts.googleapis.com/css2?family=Roboto+Mono:wght@300&display=swap" rel="stylesheet"> 

<style>
    #holder {
        flex: 1;
        display: flex;
        flex-direction: column;
        border: 1px solid gainsboro;
    }

    #headers {
        padding: 5px;
        font-size: 14px;
        font-weight: bold;
        display: none;
    }

    #title {
        padding: 15px;
        padding-bottom: 0px;
    }

    #title input {
        font-size: 32px;
        padding: 0px;
        margin: 0px;
        border: none;
        outline: none;
        width: calc(100% - 10px);
        font-weight: bold;
    }

    textarea {
        padding: 15px;
        width: 100%;
        flex: 1;
        border: none;
        outline: none;
        line-height: 1.5em;
        resize: none;
        font-size: 14px;
        font-family: 'Roboto Mono', monospace;
        overflow-y: auto;
    }

    @media (max-width:800px) {
        #title {
            padding: 5px;
            padding-bottom: 5px;
        }

        #title input {
            font-size: 22px;
        }
        #headers {
            display: none;
        }

        textarea {
            padding: 5px;
        }
    }
</style>

<div id="holder" style={edit ? "display: flex" : "display: none"}>
    <div id="title">
        <input type="text" bind:value={title} placeholder="Add A Title Here">
    </div>
    <div id="headers">
        Name, Latitude, Longitude, Description
    </div>
    <textarea
        bind:value={csv}
        bind:this={textarea}
        on:click={updateSelectedItemIndex}
        on:input={updateSelectedItemIndex}
        on:keydown={updateSelectedItemIndex}
        on:keypress={updateSelectedItemIndex}></textarea>
</div>

